export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5 text-center lg:text-left">
              ℹ️ 关于今日吃瓜
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-500 leading-relaxed">
              <p>
                今日吃瓜是一个专注热点事件汇总与追踪的内容平台。我们致力于为吃瓜群众提供
                最全面、最及时、最有趣的今日吃瓜热门大瓜内容。
              </p>
              <p>
                团队每天从微博、抖音、小红书、B站等20多个主流平台筛选最具话题性的事件，
                通过多维度整理呈现，让你在碎片时间就能掌握全网今日吃瓜事件动态。
              </p>
              <p>
                无论你是偶尔关注还是资深吃瓜达人，今日吃瓜都为你准备了从话题标签、
                热度榜单到深度专题的多层次内容体验。每日必吃，瓜不能停。
              </p>
            </div>
            <div className="flex flex-wrap gap-6 mt-6 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl font-heading text-primary-500">3年</div>
                <div className="text-xs text-foreground-400 mt-1">持续运营</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading text-accent-500">50万+</div>
                <div className="text-xs text-foreground-400 mt-1">忠实瓜友</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading text-primary-500">2万+</div>
                <div className="text-xs text-foreground-400 mt-1">累计大瓜</div>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[400px] h-[280px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20illustration%20of%20a%20modern%20content%20team%20workspace%20with%20multiple%20screens%20showing%20trending%20charts%20and%20social%20media%20feeds%2C%20stylized%20flat%20illustration%20style%2C%20coral%20and%20amber%20warm%20color%20palette%2C%20clean%20minimalist%20design%2C%20friendly%20atmosphere%2C%20editorial%20illustration%2C%20no%20text%20no%20letters%2C%20abstract%20data%20visualization%20elements&width=800&height=560&seq=about-img-2026&orientation=landscape"
              alt="今日吃瓜团队"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}